import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import React, { useEffect, useState } from 'react';
import { red, green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    base: {
      fontSize: '0.875rem',
      lineHeight: '1.46429em',
      fontWeight: theme.typography.fontWeightRegular,
      fontFamily: theme.typography.fontFamily,
      borderRadius: theme.shape.borderRadius,
    },
    messageBody: {
      display: 'flex',
      alignItems: 'center'
    },
    errorMessage: {
      maxWidth: 450,
      paddingTop: 4
    },
    progressIcon: {
      marginRight: 16
    },
    errorIcon: {
      marginRight: 8,
      color: red[500]
    },
    successIcon: {
      marginRight: 8,
      color: green[500]
    }
  })
);

interface Props {
  workflow: any;
  executionPromise: Promise<any>;
  onClose: () => void;
}

const ExecutionStatusSnackbar = React.forwardRef((props: Props, ref) => {
  const { executionPromise, workflow, onClose, ...other } = props;
  const classes = useStyles({});
  const [status, setStatus] = useState('inProgress');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (status === 'inProgress') {
      executionPromise.then(() => {
        setStatus('complete');
      }).catch((error) => {
        setStatus('failed');
        if (error.response.data.errorMessage) {
          setErrorMsg(error.response.data.errorMessage);
        } else {
          setErrorMsg('Unexpected error occurred');
        }
      });
    }
  }, [executionPromise, status]);

  useEffect(() => {
    if (status === 'complete') {
      const timeoutHandle = setTimeout(onClose, 5000);
      return () => clearTimeout(timeoutHandle);
    }
  }, [onClose, status]);

  return (
    <SnackbarContent
      ref={ref}
      className={classes.base}
      aria-describedby="client-snackbar"
      message={
        <div>
          <div className={classes.messageBody}>
            {status === 'inProgress' && <CircularProgress size={16} className={classes.progressIcon} />}
            {status === 'complete' && <CheckCircleIcon className={classes.successIcon} />}
            {status === 'failed' && <ErrorIcon className={classes.errorIcon} />}
            <div>
              {status === 'inProgress' && <div>Validating <strong>{workflow.Name}</strong></div>}
              {status === 'complete' && <div><strong>{workflow.Name}</strong> execution submitted</div>}
              {status === 'failed' && <div><strong>{workflow.Name}</strong> validation failed</div>}
              {errorMsg && <div className={classes.errorMessage}>
                {errorMsg}
              </div>}
            </div>
          </div>
        </div>
      }
      action={[
        <IconButton size="small" key="close" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ]}
      {...other}
    />
  );
});

export default ExecutionStatusSnackbar;
